import React from "react";
import CertificateLetter from "./Letters/CertificateLetter";

const CertificateValencia = ({certificate}) => {

    return (
        <>
            <div className="card-body">
                <p><strong>Fecha</strong>: {certificate.expired_date}</p>
                <p><strong>Codigo de registro</strong>: {certificate.register_number}</p>
                <p><strong>Dirección</strong>: {certificate.address}</p>
                <p><strong>Municipio</strong>: {certificate.municipality}</p>
                <p><strong>Codigo postal</strong>: {certificate.postal_code}</p>
                <p><strong>Consumo</strong>: {certificate.consumption}</p>
                <p><strong>Emisiones </strong>: {certificate.emissions}</p>
                <p><strong>Classificación consumo </strong>: <CertificateLetter
                    letter={certificate.ranking_consumption}/></p>
                <p><strong>Classificación emisiones </strong>:<CertificateLetter
                    letter={certificate.ranking_emissions}/></p>
            </div>
        </>

    );
}


export default CertificateValencia;